<template>
    <div>
        <nav-breadcrumb :menu="[{label: partnerId ? '编辑资管公司' : '新增资管公司'}]"/>

        <el-row>
            <el-col>
                <panel label="基本信息">
                    <el-form :model="dataForm" :rules="dataFormRules" ref="dataForm" label-width="150px">
                        <el-row :gutter="10" class="bg-purple xamhtrpg">
                            <el-col :span="12" v-if="dataForm.p__partnerCode==''">
                                <el-form-item label="编号：" style="width: 60%">
                                    <el-input value="待生成" disabled></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" v-if="dataForm.p__partnerCode!=''">
                                <el-form-item label="编号：" style="width: 60%">
                                    <el-input v-model="dataForm.p__partnerCode" disabled></el-input>
                                </el-form-item>
                            </el-col>

                            <el-col :span="12">
                                <el-form-item label="名称：" prop="p__partnerName" style="width: 60%" :rules="{required: true, message: '名称不能为空'}" >
                                    <el-input v-model="dataForm.p__partnerName"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="类型：" prop="p__partnerType" :rules="{required: true, message: '类型不能为空'}" style="width: 60%">
                                    <el-select placeholder="请选择类型" v-model.trim="dataForm.p__partnerType" >
                                        <el-option :label="item.label" :value="item.value" v-for="(item,idx) in partnerTypeOptions" :key="idx"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="法人：" prop="p__contactPerson" style="width: 60%" :rules="{required: true, message: '法人不能为空'}" >
                                    <el-input v-model="dataForm.p__contactPerson"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="状态：" prop="p__partnerStatus" :rules="{required: true, message: '状态不能为空'}">
                                    <el-select placeholder="请选择状态" v-model.trim="dataForm.p__partnerStatus" >
                                        <el-option :label="item.label" :value="item.value" v-for="(item,idx) in disabledOptions" :key="idx"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="联系方式：" prop="d__contactNo" style="width: 60%">
                                    <el-input v-model="dataForm.d__contactNo"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </panel>
                <panel label="账户信息">
                    <el-form :model="dataForm" :rules="dataFormRules" ref="dataForm2" label-width="150px">
                        <el-row :gutter="10" class="bg-purple xamhtrpg">

                            <el-col :span="12">
                                <el-form-item label="户名：" prop="i__accountName" style="width: 60%">
                                    <el-input v-model="dataForm.i__accountName"></el-input>
                                </el-form-item>
                            </el-col>

                            <el-col :span="12">
                                <el-form-item label="开户行：" prop="i__bankName" style="width: 60%">
                                    <el-input v-model="dataForm.i__bankName"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="银行账号：" prop="i__accountNo" style="width: 60%">
                                    <el-input v-model="dataForm.i__accountNo"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </panel>

            </el-col>
        </el-row>
        <div class="tr xzmt">
            <el-button type="primary" @click="onSubmit('dataForm')">确认提交</el-button>
            <el-button @click="$router.back()">取消</el-button>
        </div>
    </div>
</template>

<script>
    import xhr from '../../utils/xhr'
    export default {
        name: "EquitySwapPartnerAdd",
        data(){
            return {
                showCol : true,
                partnerId: this.$route.query['partnerId']||'',
                dataForm:{
                    p__partnerCode:'',
                    p__partnerStatus: 'Active'
                },
                partnerTypeOptions:[
                    {
                        label:'转让人',
                        value:'ZRR'
                    },
                    {
                        label:'受让人',
                        value:'SRR'
                    }
                ],
                disabledOptions:[
                    {
                        label:'启用',
                        value:'Active'
                    },
                    {
                        label:'禁用',
                        value:'UnActive'
                    },
                ],
                dataFormRules: {
                    i__bankName: [
                        {
                            required: false,
                            message: '不能为空！'
                        }
                    ],
                    i__accountName: [
                        {
                            required: false,
                            message: '不能为空！'
                        }
                    ],
                    i__accountNo: [
                        {
                            required: false,
                            message: '不能为空！'
                        }
                    ],
                },
            }
        },
        watch:{
            'dataForm.p__partnerType':function () {
               // alert(111)
               if(this.dataForm.p__partnerType=='ZRR'){
                   this.dataFormRules.i__bankName[0].required = true
                   this.dataFormRules.i__accountName[0].required = true
                   this.dataFormRules.i__accountNo[0].required = true

               }else{
                   this.dataFormRules.i__bankName[0].required = false
                   this.dataFormRules.i__accountName[0].required = false
                   this.dataFormRules.i__accountNo[0].required = false
               }
            },
        },
        mounted() {
            if(this.partnerId){
                this.getData()
            }
        },
        methods:{
            getData:function(){
                xhr.getEquitySwapPartner({
                        'p.partnerId': this.partnerId
                    },
                    res=> {
                        try{
                            if(res.data.status == 'success') {
                                this.dataForm = res.data.data
                            }
                        }catch (e) {

                        }
                    })
            },
            onSubmit: function (formName) {
                let dataForm = this.dataForm
                this.$refs[formName].validate(valid=> {
                    if (valid) {
                        this.$refs['dataForm2'].validate(valid2=> {
                            if (valid2) {
                                dataForm.p__checked = true
                                xhr.updateEquitySwapPartner(dataForm, res=> {
                                    try {
                                        if (res.data.status == 'success') {
                                            this.$router.push({
                                                name: 'DebtTransferList'
                                            })
                                        }
                                    } catch (e) {
                                    }
                                })
                            }
                        })

                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/EquitySwapPartnerAdd.vue